const ChatScroll = {
    install(app) {
        app.directive("chat-scroll", {
            mounted(el, binding) {
                const options = binding.value || {};

                const isAtBottom = () =>
                    el.scrollHeight - el.clientHeight <= el.scrollTop + 2;

                const scroll = () => {
                    if (options.smooth) {
                        el.scrollTo({ top: el.scrollHeight, behavior: "smooth" });
                    } else {
                        el.scrollTop = el.scrollHeight;
                    }
                };

                el._chatScrollObserver = new MutationObserver(() => {
                    const always = options.always !== false;
                    if (always || isAtBottom()) {
                        scroll();
                    }
                });

                el._chatScrollObserver.observe(el, {
                    childList: true,
                    subtree: true,
                    characterData: true,
                });

                scroll();
            },
            unmounted(el) {
                if (el._chatScrollObserver) {
                    el._chatScrollObserver.disconnect();
                }
            },
        });
    },
};

export default ChatScroll;
